import { Divider, Form, Grid, Link, Radio, Text } from '@approvalmax/ui/src/components';
import { domain } from 'modules/data';
import { memo } from 'react';

import { zeroAmountHandlingTypeName } from './ZeroAmountFormPart.constants';
import { messages } from './ZeroAmountFormPart.messages';
import { ZeroAmountFormPartProps } from './ZeroAmountFormPart.types';

const ZeroAmountFormPart = memo<ZeroAmountFormPartProps>((props) => {
    const { title, learnMoreLink } = props;

    return (
        <Form.Part>
            <Divider spacing='24 0' />

            <Grid gridTemplateColumns='auto max-content'>
                <Text font='headline' fontSize='xxsmall' spacing='0 0 16' as='h4'>
                    {title ?? messages.headline}
                </Text>

                {learnMoreLink && (
                    <Link font='body' href={learnMoreLink} external>
                        {messages.learnMore}
                    </Link>
                )}
            </Grid>

            <Radio.Group name={zeroAmountHandlingTypeName} block>
                <Radio value={domain.BudgetZeroAmountHandlingType.NotConsider}>{messages.notConsider}</Radio>

                <Radio value={domain.BudgetZeroAmountHandlingType.Consider}>{messages.consider}</Radio>
            </Radio.Group>
        </Form.Part>
    );
});

export default ZeroAmountFormPart;
